<nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
  <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
    <a class="navbar-brand brand-logo mr-5"><img src="../../../../assets/images/logo_brac.png" class="mr-2" alt="logo"/></a>
    <a class="navbar-brand brand-logo-mini"><img src="../../../../assets/images/logo_mini.png" alt="logo"/></a>
  </div>
  <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end"  >
    <!-- <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
      <span class="icon-menu"></span>
    </button> -->
    <button class="navbar-toggler align-self-center" type="button" (click)="toggleSidebar()">
      <span *ngIf="!showCross" class="icon-menu"></span>
      <span *ngIf="showCross" class="icon-cross"></span>
    </button>
    <!-- Search -->
    <!-- <ul class="navbar-nav mr-lg-2">
      <li class="nav-item nav-search d-none d-lg-block">
        <div class="input-group">
          <div class="input-group-prepend hover-cursor" id="navbar-search-icon">
            <span class="input-group-text" id="search">
              <i class="icon-search"></i>
            </span>
          </div>
          <input type="text" class="form-control" id="navbar-search-input" placeholder="Search now" aria-label="search" aria-describedby="search">
        </div>
      </li>
    </ul> -->
    <ul class="navbar-nav mr-lg-2">
      <li class="nav-item nav-search d-none d-lg-block">
        <div class="input-group">
          <div class="input-group-prepend hover-cursor" id="navbar-search-icon">
            <span class="projectName"> UPG Digitalisation System</span>
          </div>
          <!-- <input type="text" class="form-control" id="navbar-search-input" placeholder="Search now" aria-label="search" aria-describedby="search"> -->
        </div>
      </li>
    </ul>
    <ul class="navbar-nav navbar-nav-right">
      <!-- Notification -->

      <li class="nav-item dropdown">
        <a class="nav-link count-indicator dropdown-toggle" id="notificationDropdown"  data-toggle="dropdown" style="cursor: pointer;">
          <i class="icon-bell mx-0"></i>
          <span class="countNotification" *ngIf="notificationList.length > 0">{{notificationList.length}}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" style="    width: 500px;
        height: 400px;
        overflow-y: auto;" aria-labelledby="notificationDropdown">

          <app-notification-main></app-notification-main>
        </div>
      </li>
      <!-- Profile -->
      <li class="nav-item nav-profile dropdown">
        <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown" id="profileDropdown">
          <!-- <img src="../../../../assets/images/face28.jpg" alt="profile"/> -->
          <div class="profilePicWithText">{{profileName}}</div>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
          <div class="proName">{{sessionUser.email}}</div>
          <div class="proName">({{sessionUser.role.short_form}})</div>
          <!-- <a class="dropdown-item" (click)="showProfile()">
            <i class="ti-user text-primary"></i>
            Profile
          </a> -->
          <a class="dropdown-item" (click)="changePassword()">
            <i class="ti-key text-primary"></i>
            Change password
          </a>
          <a class="dropdown-item" (click)="showProgramPopUp()" *ngIf="!isAdmin">
            <i class="ti-receipt text-primary"></i>
            Cohort Change
          </a>
          <a class="dropdown-item" (click)="logout()">
            <i class="ti-power-off text-primary"></i>
            Logout
          </a>
        </div>
      </li>
    </ul>
    <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
      <span class="icon-menu"></span>
    </button>
  </div>
</nav>
<a id="backToTopBtn" title="Back to top"></a>
<dx-popup
    [(visible)]="isProfilePopUpVisible"
    [closeOnOutsideClick]="false"
    [showTitle]="true"
    title="Profile"
    [dragEnabled]="true"
    position="center"
    [height]="300"
    [width]="500">

    <div>
      <div class="profilePicWithText2">
        <div>
          {{profileName}}
        </div>
      </div>
      <div class="info">
        <p>
          Email: <span>{{sessionUser.email}}</span>
        </p>
        <p>
          Role: <span>{{sessionUser.role.role_name}} ({{sessionUser.role.short_form}})</span>
        </p>
        <!-- <p>
          Role Short Form: <span>{{sessionUser.role.short_form}}</span>
        </p> -->
      </div>
    </div>

</dx-popup>

<dx-popup
    *ngIf="popupVisible_program"
    [showTitle]="true"
    title= "Select Cohort"
    [dragEnabled]="false"
    hideOnOutsideClick="true"
    [showCloseButton]="false"
    container=".dx-viewport"
    width="500"
    height="250"
    [(visible)]="popupVisible_program"
  >
    <dxi-toolbar-item
      widget="dxButton"
      toolbar="top"
      location="after"
      [options]="closeButtonOptions"
    > </dxi-toolbar-item>
    <dxo-position at="center" my="center" of="window" collision="fit"> </dxo-position>
    <div *dxTemplate="let data of 'content'">

      <app-programme (closePopUpCLick)="closeProgramPopUp()" [userInfo]="userInfo"></app-programme>
    </div>
  </dx-popup>
